// Card image mapping for Bitarot cards
// Maps card IDs to their image paths

export const getCardImage = (cardId) => {
  const cardImages = {
    // Major Arcana (0-21) - All 22 cards with custom artwork
    'major-0': '/cards/major/0-the-fool.jpg',
    'major-1': '/cards/major/1-the-magician.jpg',
    'major-2': '/cards/major/2-high-priestess.jpg',
    'major-3': '/cards/major/3-the-empress.jpg',
    'major-4': '/cards/major/4-the-emperor.jpg',
    'major-5': '/cards/major/5-the-hierophant.jpg',
    'major-6': '/cards/major/6-the-lovers.jpg',
    'major-7': '/cards/major/7-the-chariot.jpg',
    'major-8': '/cards/major/8-strength.jpg',
    'major-9': '/cards/major/9-the-hermit.jpg',
    'major-10': '/cards/major/10-wheel-of-fortune.jpg',
    'major-11': '/cards/major/11-justice.jpg',
    'major-12': '/cards/major/12-the-hanged-man.jpg',
    'major-13': '/cards/major/13-death.jpg',
    'major-14': '/cards/major/14-temperance.jpg',
    'major-15': '/cards/major/15-the-devil.jpg',
    'major-16': '/cards/major/16-the-tower.jpg',
    'major-17': '/cards/major/17-the-star.jpg',
    'major-18': '/cards/major/18-the-moon.jpg',
    'major-19': '/cards/major/19-the-sun.jpg',
    'major-20': '/cards/major/20-judgement.jpg',
    'major-21': '/cards/major/21-the-world.jpg',
    
    // Minor Arcana - Cups (Ace through Ten using same beautiful image)
    'cups-ace': '/cards/cups/ace-of-cups.jpg',
    'cups-2': '/cards/cups/ace-of-cups.jpg',
    'cups-3': '/cards/cups/ace-of-cups.jpg',
    'cups-4': '/cards/cups/ace-of-cups.jpg',
    'cups-5': '/cards/cups/ace-of-cups.jpg',
    'cups-6': '/cards/cups/ace-of-cups.jpg',
    'cups-7': '/cards/cups/ace-of-cups.jpg',
    'cups-8': '/cards/cups/ace-of-cups.jpg',
    'cups-9': '/cards/cups/ace-of-cups.jpg',
    'cups-10': '/cards/cups/ace-of-cups.jpg',
    
    // Minor Arcana - Swords (Ace through Ten using same beautiful image)
    'swords-ace': '/cards/swords/ace-of-swords.jpg',
    'swords-2': '/cards/swords/ace-of-swords.jpg',
    'swords-3': '/cards/swords/ace-of-swords.jpg',
    'swords-4': '/cards/swords/ace-of-swords.jpg',
    'swords-5': '/cards/swords/ace-of-swords.jpg',
    'swords-6': '/cards/swords/ace-of-swords.jpg',
    'swords-7': '/cards/swords/ace-of-swords.jpg',
    'swords-8': '/cards/swords/ace-of-swords.jpg',
    'swords-9': '/cards/swords/ace-of-swords.jpg',
    'swords-10': '/cards/swords/ace-of-swords.jpg',
    
    // Minor Arcana - Wands (Ace through Ten using same beautiful image)
    'wands-ace': '/cards/wands/ace-of-wands.jpg',
    'wands-2': '/cards/wands/ace-of-wands.jpg',
    'wands-3': '/cards/wands/ace-of-wands.jpg',
    'wands-4': '/cards/wands/ace-of-wands.jpg',
    'wands-5': '/cards/wands/ace-of-wands.jpg',
    'wands-6': '/cards/wands/ace-of-wands.jpg',
    'wands-7': '/cards/wands/ace-of-wands.jpg',
    'wands-8': '/cards/wands/ace-of-wands.jpg',
    'wands-9': '/cards/wands/ace-of-wands.jpg',
    'wands-10': '/cards/wands/ace-of-wands.jpg',
    
    // Minor Arcana - Pentacles (Ace through Ten using same beautiful image)
    'pentacles-ace': '/cards/pentacles/ten-of-pentacles.jpg',
    'pentacles-2': '/cards/pentacles/ten-of-pentacles.jpg',
    'pentacles-3': '/cards/pentacles/ten-of-pentacles.jpg',
    'pentacles-4': '/cards/pentacles/ten-of-pentacles.jpg',
    'pentacles-5': '/cards/pentacles/ten-of-pentacles.jpg',
    'pentacles-6': '/cards/pentacles/ten-of-pentacles.jpg',
    'pentacles-7': '/cards/pentacles/ten-of-pentacles.jpg',
    'pentacles-8': '/cards/pentacles/ten-of-pentacles.jpg',
    'pentacles-9': '/cards/pentacles/ten-of-pentacles.jpg',
    'pentacles-10': '/cards/pentacles/ten-of-pentacles.jpg',
    
    // Court Cards - Pages
    'cups-page': '/cards/cups/page-of-cups.jpg',
    'swords-page': '/cards/swords/page-of-swords.jpg',
    'wands-page': '/cards/wands/page-of-wands.jpg',
    'pentacles-page': '/cards/pentacles/page-of-pentacles.jpg',
    
    // Court Cards - Knights
    'cups-knight': '/cards/cups/knight-of-cups.jpg',
    'swords-knight': '/cards/swords/knight-of-swords.jpg',
    'wands-knight': '/cards/wands/knight-of-wands.jpg',
    'pentacles-knight': '/cards/pentacles/knight-of-pentacles.jpg',
    
    // Court Cards - Queens
    'cups-queen': '/cards/cups/queen-of-cups.jpg',
    'swords-queen': '/cards/swords/queen-of-swords.jpg',
    'wands-queen': '/cards/wands/queen-of-wands.jpg',
    'pentacles-queen': '/cards/pentacles/queen-of-pentacles.jpg',
    
    // Court Cards - Kings (THE FINAL FOUR!)
    'cups-king': '/cards/cups/king-of-cups.jpg',
    'swords-king': '/cards/swords/king-of-swords.jpg',
    'wands-king': '/cards/wands/king-of-wands.jpg',
    'pentacles-king': '/cards/pentacles/king-of-pentacles.jpg',
  };

  return cardImages[cardId] || null;
};

export const hasCardImage = (cardId) => {
  return getCardImage(cardId) !== null;
};
